"use client";
import { usePathname, useParams } from "next/navigation";

import Link from "next/link";
import { cn, LOCALES } from "@/lib/utils";
import { Button } from "@/components/ui/button";

import { ChevronDown } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import Cookies from "js-cookie";

// TODO: Remove duplicate of this
const LOCALE_COOKIE_NAME = "PREFERRED_LOCALE";

export default function LanguageSwitcher({
  align = "start",
  background = false,
  size = "md",
}) {
  const params = useParams();
  const localKeys = LOCALES.map((l) => l.value);
  const locale = localKeys.includes(params?.lang) ? params?.lang : "en";

  const pathname = usePathname();

  const getHref = (lang) => {
    const path = pathname.replace(/^\/[a-z]{2}/, "");
    return lang === "en" ? path || "/" : `/${lang}${path}`;
  };

  const handleLanguageChange = (lang) => {
    // Set the cookie with a 1-year expiry
    Cookies.set(LOCALE_COOKIE_NAME, lang, { expires: 365 });
    window.location.href = getHref(lang);
  };

  const SelectedFlag = LOCALES.find((l) => l.value === locale)?.flag;
  const selectedValue = LOCALES.find((l) => l.value === locale)?.value;
  // const selectedLabel = LOCALES.find((l) => l.value === locale)?.label;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          className={cn(
            "w-auto p-1.5 h-auto rounded-md py-1 text-foreground",
            background
              ? "bg-white"
              : "bg-transparent text-white hover:bg-white/10 hover:text-white -mr-2"
          )}
        >
          <div className="flex items-center gap-1">
            <SelectedFlag className="w-5 rounded-md" />
            <span
              className={cn(
                "text-sm font-normal ml-0.5",
                size === "sm" && "text-xs"
              )}
            >
              {selectedValue?.toUpperCase()}
            </span>
            <ChevronDown
              className={cn(
                "size-2 ",
                background
                  ? "fill-gray-500 stroke-gray-500"
                  : "fill-white stroke-white"
              )}
            />
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto min-w-[110px] px-0.5 py-0.5"
        align={align}
      >
        <div className="flex flex-col divide-y">
          {LOCALES.map((locale) => (
            <Link
              key={locale?.value}
              href={getHref(locale?.value)}
              onClick={() => handleLanguageChange(locale?.value)}
              className="flex items-center gap-2 rounded-none px-2 py-1.5 hover:bg-accent cursor-pointer"
            >
              <locale.flag className="w-4.5 rounded-[3px]" />
              <span className="text-sm ">{locale?.label}</span>
            </Link>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
